import React from 'react'
import { Skeleton } from "primereact/skeleton";
//this is card Skeleton used to display when data is loading
export default function BuyPropertyCardSkeleton() {
  return (
   <div className="border-round-lg surface-card shadow-2 overflow-hidden rounded-3" >
  
  
  <div className="relative">
    <Skeleton width="100%" height="180px" />
    <div
      className="absolute top-0 right-0 m-2"
      style={{ background: "#fff", borderRadius: "50%", padding: "6px" }}
    >
      <Skeleton shape="circle" size="1.5rem" />
    </div>
  </div>

 
  <div className="p-3">
    <Skeleton width="60%" height="1.2rem" className="mb-2" />
    <Skeleton width="80%" height="0.9rem" className="mb-2" />
    <Skeleton width="50%" height="0.9rem" className="mb-3" />
    <Skeleton width="70%" height="1.3rem" />
  </div>
</div>

  )
}
